import React from 'react';
import { Textarea } from './ui/textarea';
import { RichTextEditor } from './RichTextEditor';
import { NextStepsEditor } from './NextStepsEditor';

export const MeetingBlock = ({ bloque, index, respuestas, onAnswer, steps, onSteps }) => (
  <section className="rounded-xl border overflow-hidden" data-testid={`meeting-block-${index}`}>
    <h3 className="px-4 py-2.5 font-semibold bg-muted/60 border-b">{bloque.titulo}</h3>
    {bloque.guion_html && (
      <div className="px-4 py-3 bg-amber-50/60 border-b text-sm text-stone-700" data-testid={`meeting-block-${index}-guion`}>
        <p className="text-[10px] font-bold uppercase tracking-widest text-amber-700 mb-1">Guion</p>
        <RichTextEditor value={bloque.guion_html} editable={false} testId={`meeting-block-${index}-guion-content`} />
      </div>
    )}
    {(bloque.campos.length > 0 || bloque.proximos_pasos) && (
      <div className="p-4 space-y-3">
        {bloque.campos.map((c, i) => (
          <div key={c.id} className="space-y-1">
            <label className="text-sm font-medium" htmlFor={`f-${c.id}`}>{c.label}</label>
            <Textarea id={`f-${c.id}`} value={respuestas[c.id] || ''} onChange={(e) => onAnswer(c.id, e.target.value)}
              rows={2} className="min-h-[60px]" data-testid={`meeting-block-${index}-field-${i}`} />
          </div>
        ))}
        {bloque.proximos_pasos && (
          <div className="space-y-1">
            <p className="text-sm font-medium">Próximos pasos y fecha</p>
            <NextStepsEditor steps={steps} onChange={onSteps} />
          </div>
        )}
      </div>
    )}
  </section>
);
